export default __webpack_public_path__ + "static/media/survey-fashion.29310729.png";